const getters = {
  brand: state => state.brand,
  brandInfo: state => state.brand.info,
  searchKeyWord: state => state.brand.searchKeyWord,
  urlInfo: state => state.brand.urlInfo,
  permissionInfo: state => state.brand.permissionInfo,
  // 後台「前台顯示註冊」開關（enable_register_frontend_display）；0 = 線下站，帳號由代理發放，前台只有登入。後端未提供欄位時視為開放註冊
  isLoginOnly: state => state.brand.permissionInfo.enable_register_frontend_display === 0,
  // 帳號設定頁（/user/edit）是否有內容：個資與 KYC 都關閉時整頁空白，改由安全中心（/user/verify）取代
  showAccountSetting: state => state.brand.permissionInfo.register_need_member_info !== 0 ||
    state.brand.permissionInfo.enable_kyc_certification !== 0,
  webInfo: state => state.brand.webInfo,
  brandImage: state => state.brand.brandImage,
  brandImageCheckKey: state => (key) => {
    // 舊版快取的 brandImage 預設值為 null
    if (!state.brand.brandImage || state.brand.brandImage[key] === undefined) return false
    else return true
  },
  brandCode: state => state.brand.info.code,
  customerServiceInfo: state => state.brand.customerServiceInfo,
  googleLoginClientId: state => state.brand.googleLoginClientId,
  game: state => state.game,
  gameCategory: state => state.game.gameCategory,
  gameProvider: state => state.game.gameProvider,
  goldInfo: state => state.user.goldInfo,
  mainTotal: state => (state.user.goldTotal !== undefined && state.user.goldTotal !== null) ? state.user.goldTotal : 0,
  gold: state => (state.user.goldInfo !== undefined && state.user.goldInfo !== null) ? state.user.goldInfo.gold : 0,
  commonGold: state => (state.user.goldInfo !== undefined && state.user.goldInfo !== null) ? state.user.goldInfo.common_gold : 0,
  commissionGold: state => (state.user.commissionGold !== undefined && state.user.commissionGold !== null) ? state.user.commissionGold : 0,
  mainGold: state => (state.user.mainGold !== undefined && state.user.mainGold !== null) ? state.user.mainGold : 0,
  bonusGold: state => (state.user.bonusGold !== undefined && state.user.bonusGold !== null) ? state.user.bonusGold : 0,
  mainPoint: state => (state.user.mainPoint !== undefined && state.user.mainPoint !== null) ? state.user.mainPoint : 0,
  mainTurnover: state => (state.user.mainTurnover !== undefined && state.user.mainTurnover !== null) ? state.user.mainTurnover : 0,
  point: state => state.user.point,
  gameBalance: state => state.user.gameBalanceInfo,
  name: state => state.user.memberInfo ? state.user.memberInfo.nickname : 'Guest',
  user: state => state.user,
  language: state => state.user.language,
  supportLanguages: state => state.user.supportLanguages,
  deviceInfo: state => state.user.deviceInfo,
  memberInfo: state => state.user.memberInfo,
  // 會員層級入金開關（/user/me 的 enable_deposit）；0 = 隱藏所有存款入口。未登入或後端未提供欄位時視為允許
  canMemberDeposit: state => !(state.user.memberInfo && Number(state.user.memberInfo.enable_deposit) === 0),
  // 線下代理身份（member_type=4 本人，或 prompt_member_type=4 上線為線下代理）；此類會員僅能使用主錢包，且不可錢包互轉
  isOfflineAgentMember: state => {
    const member = state.user.memberInfo
    if (!member) return false
    return Number(member.member_type) === 4 || Number(member.prompt_member_type) === 4
  },
  socialType: state => state.user.socialType,
  token: state => state.user.token,
  setUsernameToken: state => state.user.setUsernameToken,
  setUsernameCredential: state => state.user.setUsernameCredential,
  app: state => state.app,
  isLoading: state => state.app.isLoading,
  inGameId: state => state.app.inGameId,
  leaveGamePath: state => state.app.leaveGamePath,
  inviteCode: state => state.user.inviteCode,
  shareCode: state => state.user.shareCode,
  couponCode: state => state.user.couponCode,
  btag: state => state.user.btag,
  group: state => state.user.group,
  // 載入狀態分三層：公開正文可讀（loadCompleted）→ 品牌資料就緒 → 會員功能可開放
  loadCompleted: state => state.app.loadCompleted,
  brandReady: state => state.app.brandStatus === 'ready',
  brandFailed: state => state.app.brandStatus === 'failed',
  memberReady: state => state.app.loadCompleted && state.app.brandStatus === 'ready',
  noticeMessage: state => state.app.noticeMessage,
  requestMessage: state => state.app.requestMessage,
  adMessage: state => state.app.adMessage,
  isApiExecute: state => state.app.isApiExecute,
  toastMessage: state => state.app.toastMessage,
  errorMessage: state => state.app.errorMessage,
  readTerms: state => state.brand.readTerms,
  readAnnouncement: state => state.brand.readAnnouncement,
  supportPhoneCode: state => state.brand.supportPhoneCode,
  showGameWalletModal: state => state.app.showGameWalletModal,
  currentTheme: state => state.brand.theme,
  showSearch: state => state.brand.showSearch,
  gameIdsArray: state => state.app.gameIdsArray,
  walletInfo: state => state.user.walletInfo,
  agreeCookie: (state) => {
    // Check if the preference is stored in a cookie
    const isAgreeCookie = document.cookie.split('; ').find((item) => item.startsWith('isAgreeCookie='))
    if (isAgreeCookie) {
      return isAgreeCookie.split('=')[1] === 'true'
    } else {
      state.app.isAgreeCookie = false
    }
    // Use the value from the Vuex state
    return state.app.isAgreeCookie
  },
  // 玩家是否已回應過 cookie 詢問(同意或不同意),回應後不再顯示
  cookieResponded: state => state.app.isCookieResponded
}
export default getters
